export const buildClassicDateFormat = (date_str) => {
    let date = new Date(date_str);
    return `${date.getDate()} / ${date.getMonth() + 1} / ${date.getFullYear()}`;
} 

export const buildTimeStampString = (date) => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
}